var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "award-05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.125 21.375C10.125 30.6947 17.6802 38.25 27 38.25C36.3197 38.25 43.875 30.6947 43.875 21.375C43.875 12.0552 36.3197 4.5 27 4.5C17.6802 4.5 10.125 12.0552 10.125 21.375Z",
    stroke: "white",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.25 22.8751C20.25 22.8751 21.9375 22.8751 23.625 25.875C23.625 25.875 28.9854 18.375 33.75 16.875",
    stroke: "white",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.9856 33.75L39.4936 40.9723C40.4624 45.6127 40.9468 47.9329 39.9517 49.0327C38.9567 50.1322 37.2285 49.1864 33.7723 47.2946L28.6569 44.4944C27.8402 44.0473 27.4318 43.8239 27 43.8239C26.5682 43.8239 26.1599 44.0473 25.3431 44.4944L20.2277 47.2946C16.7714 49.1864 15.0433 50.1322 14.0482 49.0327C13.0531 47.9329 13.5376 45.6127 14.5064 40.9723L16.0144 33.75",
    stroke: "white",
    strokeWidth: 3.375,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.86f533e31939c87c83d138d855fb864d.svg";
export { ForwardRef as ReactComponent };